import React, { useRef } from "react";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const FileSubmission = ({handleSubmitData, file, handleFileChange, handleDeleteFile, noFile, handleAckChange, error}) => {

	const ref = useRef();

	const onSubmitButtonClicked = (e) => {
		console.log("filele", file)
		confirmAlert({
			title: 'Submit peer review and file',
			message: file === null ? 
			'Are you sure you want to submit peer review with no file to submit?' 
			: `Are you sure you want to submit peer review and file ${file['name']}?`,
			
			buttons: [
				{
					label: 'Yes',
					onClick: () => handleSubmitData(e)
				},
				{
					label: 'No',
					onClick: () => null
				},
			]
			});
	}

	return (
		<div className='file-submission-section'>
			<h3>Submission</h3>
			<div class="form-file">
				<h4 class="form-label submission-add-file">Add File</h4>

				{
					!noFile && 
					<div class="form-file__input">
						<input
							class="form-input"
							type="file" 
							name="file" 
							onChange={handleFileChange}
							ref={ref}
						/>
						{
							file !== null && 
							<>
								<button 
									className="postcall-delete-file"
									onClick={() => handleDeleteFile(ref)}>
									Delete File
								</button>
							</>
						}
					</div>
				}
				
				<input type="checkbox" name="no-submission" value={noFile} onChange={handleAckChange} className='submission-ack'></input>
				<label htmlFor="no-submission" className='normal-text submission-ack'>I submit without a file.</label>
				{
					error !== null &&
					<p className='peer-review-warning'>{error}</p>
				}
			</div>
			<button 
				type="button"
				onClick={onSubmitButtonClicked}
				className='wiyata-btn' 
			>
				Submit
			</button>
		</div>
	);
}
 
export default FileSubmission;